import { render, staticRenderFns } from "./TomTest.vue?vue&type=template&id=7a2be1b8&"
import script from "./TomTest.vue?vue&type=script&lang=js&"
export * from "./TomTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports